import { useEffect } from 'react';

interface CanonicalTagProps {
  url: string;
}

const CanonicalTag = ({ url }: CanonicalTagProps) => {
  useEffect(() => {
    // Remove any existing canonical links
    const existingCanonical = document.querySelector('link[rel="canonical"]');
    if (existingCanonical) {
      existingCanonical.remove();
    }

    // Add the new canonical link
    const link = document.createElement('link');
    link.rel = 'canonical';
    link.href = url;
    document.head.appendChild(link);

    return () => {
      // Cleanup on unmount
      const canonicalLink = document.querySelector(`link[rel="canonical"][href="${url}"]`);
      if (canonicalLink) {
        canonicalLink.remove();
      }
    };
  }, [url]);

  return null;
};

export default CanonicalTag;